import React from 'react'
import createG2 from 'g2-react'
import compose from 'recompose/compose'
import { inject, observer } from 'mobx-react'
import _values from 'lodash/values'
import _get from 'lodash/get'
import _set from 'lodash/set'
// import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'
import moment from 'moment'
import config from '~/config'
const colors = _values(config.ui.colors)

const ResponseDataChart = ({ dataRecords, dataTypeIds = [], category, view: { mode, daysOffset }, data: { now } }) => {
  const startDate = moment(now).subtract({ days: 7 }).format('YYYY-MM-DD@HH:mm:ss')
  const endDate = moment(now).add({ days: 1 }).format('YYYY-MM-DD@HH:mm:ss')

  // let max = 0
  const dataValues = _values(dataRecords.reduce((result, rec) => {
    // console.log(rec.observedTimestamp)
    // max = rec.value > max ? rec.value : max
    _set(result, [rec.observedTimestamp, rec.type.name], rec.value)
    _set(result, [rec.observedTimestamp, 'observedTimestamp'], moment(rec.observedTimestamp).format('YYYY-MM-DD@HH:mm:ss'))
    // _set(result, [rec.observedTimestamp, 'observedTimestampISO'], moment(rec.observedTimestamp).toISOString())
    return result
  }, {}))
  const dataSource = _sortBy(dataValues, ['observedTimestamp'])
  let observedTimestamp

  const Line = createG2(chart => {
    let offset = 5
    dataTypeIds.forEach((typeId, i) => {
      const typeConfig = _get(config, 'app.parameters').find(t => t.id === parseInt(typeId, 10))
      const typeName = _get(typeConfig, 'name')

      chart.axis(typeName, {
        position: 'left',
        labels: {
          label: {
            fill: colors[i],
            fontSize: 8
          },
          autoRotate: false
        },
        labelOffset: offset,
        title: {
          fontSize: 10,
          fontWeight: 'bold',
          fill: colors[i],
          textAlign: 'center'
        },
        titleOffset: offset + 24
      })
      chart.col(typeName, {
        // min: _get(typeConfig, 'min'),
        // max: _get(typeConfig, 'max'),
        // max,
        alias: `${_get(typeConfig, 'name')} (${_get(typeConfig, 'unit', '')})`
      })
      if (observedTimestamp) {
        chart.guide().line([observedTimestamp, _get(typeConfig, 'min')], [observedTimestamp, _get(typeConfig, 'max')], {
          stroke: '#999'
          // lineDash: [0, 2, 2],
          // lineWidth: 3
        })
      }
      offset += 40
      chart.line().position(`observedTimestamp*${typeName}`).color(colors[i]).shape('spline').size(2)
    })
    // chart.guide().text({
    //   // top: true,
    //   content: 'titleXXX',
    //   position: [10, 10],
    //   style: {
    //     // fill: '#666',
    //     fontSize: '24',
    //     fontWeight: 'bold',
    //     rotate: 30
    //   }
    // })
    let prevDate
    chart.axis('observedTimestamp', {
      formatter: (dateTime, item, index) => {
        const $dateTime = moment(dateTime, 'YYYY-MM-DD@HH:mm:ss', true)
        if (!$dateTime.isSame(prevDate, 'day')) {
          prevDate = $dateTime
          // return $dateTime.format('YYYY-MM-DD')
          return $dateTime.format('MMM DD')
        }
        prevDate = $dateTime
        return $dateTime.format('HH:mm:ss')
      },
      labels: {
        label: {
          textAlign: 'right',
          fontSize: 8,
          textBaseline: 'top',
          rotate: -45 * Math.PI / 180
        },
        autoRotate: false
      },
      labelOffset: 0,
      title: false
    })
    chart.col('observedTimestamp', {
      nice: true,
      tickCount: 22,
      min: startDate,
      max: endDate
    })
    chart.legend(false)
    chart.render()
  })
  return <Line data={dataSource} width={_get(config, 'ui.chartWidth')} height={_get(config, 'ui.chartHeight') + 88} plotCfg={{
    margin: [10, 10, 70, 160]
  }} />
}

export default compose(
  inject('data'),
  inject('view'),
  observer
)(ResponseDataChart)



// WEBPACK FOOTER //
// ./src/modules/Monitoring/ResponseDataChart.js